import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { Product, useApp } from '../context/AppContext';

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  const { dispatch } = useApp();
  const navigate = useNavigate();

  const handleAddToCart = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch({ type: 'ADD_TO_CART', payload: product });
  };

  const handleBuyNow = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch({ type: 'ADD_TO_CART', payload: product });
    navigate('/checkout');
  };

  return (
    <div className="bg-gray-900 rounded-3xl overflow-hidden border border-gray-800 hover:border-gray-700 transition-all duration-300 hover:shadow-xl">
      <Link to={`/product/${product.id}`}>
        <div className="relative">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-48 sm:h-56 md:h-64 object-cover"
          />
          {product.discount && (
            <div className="absolute top-3 right-3">
              <div className="bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full flex items-center space-x-1">
                <span>✓</span>
                <span>{product.discount}% off</span>
              </div>
            </div>
          )}
        </div>
      </Link>

      <div className="p-4 sm:p-6">
        <Link to={`/product/${product.id}`}>
          <h3 className="text-white font-semibold mb-2 hover:text-gray-300 transition-colors text-sm sm:text-base">
            {product.name}
          </h3>
          
          <p className="text-gray-400 text-xs sm:text-sm mb-3 line-clamp-2">
            {product.description}
          </p>

          <div className="flex items-center space-x-2 mb-4">
            {product.originalPrice && (
              <span className="text-gray-500 line-through text-xs sm:text-sm">
                ₹{product.originalPrice.toLocaleString()}
              </span>
            )}
            <span className="text-green-400 text-lg sm:text-xl font-bold">
              ₹{product.price.toLocaleString()}
            </span>
          </div>
        </Link>

        <div className="flex flex-col sm:flex-row gap-2">
          <button
            onClick={handleAddToCart}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-full flex items-center justify-center space-x-2 transition-colors font-semibold text-sm"
          >
            <ShoppingCart className="w-4 h-4" />
          </button>
          
          <button
            onClick={handleBuyNow}
            className="flex-1 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded-full font-semibold transition-all transform hover:scale-105 text-sm"
          >
            Buy Now
          </button>
        </div>

        <div className="mt-3 text-center">
          <span className={`text-xs ${product.inStock ? 'text-green-400' : 'text-red-400'}`}>
            {product.inStock ? '✓ In Stock' : '✗ Out of Stock'}
          </span>
        </div>
      </div>
    </div>
  );
}